<template>
  <div id="app">
    <router-view/>
    <InstallBanner />
  </div>
</template>

<script>
import InstallBanner from '@/components/InstallBanner.vue'

export default {
  name: 'App',
  components: {
    InstallBanner
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
}

body {
  margin: 0;
  padding: 0;
}

.primary-color {
  color: #4A90E2;
}

.primary-bg {
  background-color: #4A90E2;
}

.secondary-color {
  color: #28a745;
}

.secondary-bg {
  background-color: #28a745;
}

.text-bold {
  font-weight: bold;
}

.pointer {
  cursor: pointer;
}

.overflow-hidden {
  overflow: hidden;
}

.nav-link.active {
  background-color: rgba(74, 144, 226, 0.2);
  color: #4A90E2 !important;
}

.btn-primary {
  background-color: #4A90E2;
  border-color: #4A90E2;
}

.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}

.full-height {
  height: 100vh;
}
</style>
